import { AuditableModel } from '../../Misc/models/auditable.model';
import { MailingListApiModel, CreateMailingListApiModel, UpdateMailingListApiModel } from '../../../api/mailingLists/models/mailingList.api.model';

export class MailingListModel implements AuditableModel {
    id: number;
    name: string;
    recipientIds: number[];

    createdByUserId?: number;
    createdDate?: Date;
    modifiedByUserId?: number;
    modifiedDate?: Date;
    count?: number;

    constructor(apiModel?: MailingListApiModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.name = apiModel.name;
            this.recipientIds = apiModel.recipientIds?.slice() || [];
            this.count = this.recipientIds.length;
            this.createdByUserId = apiModel.createdByUserId;
            this.createdDate = apiModel.createdDate ? new Date(apiModel.createdDate) : null;
            this.modifiedByUserId = apiModel.modifiedByUserId;
            this.modifiedDate = apiModel.modifiedDate ? new Date(apiModel.modifiedDate) : null;
        } else {
            this.recipientIds = [];
        }
    }

    getCreateApiModel(): CreateMailingListApiModel {
        return {
            name: this.name,
            recipientIds: this.recipientIds.slice()
        };
    }
    getUpdateApiModel(): UpdateMailingListApiModel {
        return {
            id: this.id,
            name: this.name,
            recipientIds: this.recipientIds.slice()
        };
    }
    clone(): MailingListModel {
        return new MailingListModel({
            id: this.id,
            name: this.name,
            recipientIds: this.recipientIds.slice(),
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate ? +this.createdDate : null,
            modifiedByUserId: this.modifiedByUserId,
            modifiedDate: this.modifiedDate ? +this.modifiedDate : null
        });
    }
}
